import React, { useMemo } from 'react';
import { Select as SelectAntd } from 'antd';
import styled from 'styled-components';

import { getOperatorText } from '../../utils/filter';
import { nullOperators, singleValuesOperators, types } from '../../constants/filter';
import Select from '../common/Select';

const MultipleValuesSelectorContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  width: 100%;
`;

const StyledSelectAntd = styled(SelectAntd)`
  min-width: 120px;
  max-width: 120px;
  flex-shrink: 0;
`;

const StyledSelectContainer = styled.div`
  margin-left: 10px;
  min-width: 125px;
  max-width: calc(100% - 150px);
`;

const StyledSelect = styled(Select)`
  width: 100%;

  .ant-select-selection-overflow-item {
    display: block;
  }
`;

const MultipleValuesSelector = ({
  onSelectOperator,
  onValueChange,
  operator,
  operators,
  value,
  values,
  type,
  customizable = true,
  operatorStyle = {},
  operatorValueStyle = {},
}) => {
  const onSelectHandler = (c) => {
    const checkSingleValuesOperators = !!(
      // eslint-disable-next-line no-bitwise
      (singleValuesOperators.includes(c) ^ singleValuesOperators.includes(operator))
    );
    // eslint-disable-next-line no-bitwise
    const checkNullOperators = !!(nullOperators.includes(c) ^ nullOperators.includes(operator));

    const resetValue = checkSingleValuesOperators || checkNullOperators;

    onSelectOperator(c, resetValue);
  };

  const getPopupContainer = (triggerNode) => triggerNode;

  const options = useMemo(
    () =>
      operators.map((c) => ({
        label: getOperatorText(c),
        value: c,
      })),
    [operators]
  );

  const isShowAdditionalSelect = !nullOperators.includes(operator);

  const isMulti = !singleValuesOperators.find((c) => c === operator);

  return (
    <MultipleValuesSelectorContainer>
      <StyledSelectAntd
        style={{ ...operatorStyle }}
        dropdownMatchSelectWidth
        dropdownStyle={{ width: 'auto' }}
        value={operator || undefined}
        onSelect={onSelectHandler}
        className="ant-select-border-bottom"
        getPopupContainer={getPopupContainer}
        virtual={false}
        options={options}
      />
      {isShowAdditionalSelect && (
        <StyledSelectContainer style={{ ...operatorValueStyle }}>
          <StyledSelect
            className="ant-select-border-bottom"
            multi={isMulti}
            customizable={customizable}
            useJSON={type !== types.STRING}
            onChange={onValueChange}
            value={value}
            values={values}
            virtual={false}
            getPopupContainer={getPopupContainer}
          />
        </StyledSelectContainer>
      )}
    </MultipleValuesSelectorContainer>
  );
};

export default MultipleValuesSelector;
